<template>
  <div class="w3-left-align">
    <i class="fa fa-inbox flow-main-color w3-xlarge w3-margin-right"></i>
    <!-- domain icon -->
    <ContentHeader v-bind:title="$t('editDomain')" />
    <div class="w3-margin-top w3-margin-bottom w3-left-align">
      <Column>
        <Row>
          <div class="grid-component">
            <StandardTextBox
              :np-name-error="!domain.name ? $t('INVALID_NAME') : ''"
              v-model:modelText="safeFormData.name"
              :label-name="'name'"
            />
          </div>
          <div class="grid-component">
            <label class="w3-left flow-main-color flow-padding-bottom">{{
                $t("domainType")
              }}</label>
            <div class="w3-col w-100pc flow-margin-right sort-select">
              <StandardSelect
                :callback="setSelectedType"
                :items="this.getDomainTypes"
                :preSelectedItem="safeFormData.type"
                :valueKey="'name'"
                :valueKeyIndex="'id'"
                class="w3-border w3-round-medium"
                type="text"
              />
            </div>
          </div>
        </Row>
        <Row>
          <div class="grid-component">
            <StandardTextBox
              :np-name-error="prefixError"
              v-model:modelText="safeFormData.prefix"
              :label-name="'prefix'"
              :placeholder="'prefix-example'"
            />
          </div>

          <div class="grid-component">
            <label class="w3-left flow-main-color flow-padding-bottom">
              {{ $t("useContactWaitingRoom") }}
              <i class="fa fa-xs fa-question-circle cursor-pointer" :title="$t('useContactWaitingRoom-description')"/>
            </label>
            <div class="w3-col zero flow-margin-right sort-select flow-btn-checkbox w3-left-align"
                 @click.prevent="()=> {domain.useContactWaitingRoom = !domain.useContactWaitingRoom}"
                 v-bind:class="
                domain.useContactWaitingRoom ? 'active' : 'inactive'">
              <div class="flow-btn-checkbox-icon">
                <i class="fa"></i>
              </div>
            </div>
          </div>

          <div class="grid-component">
            <label class="w3-left flow-main-color flow-padding-bottom">
              {{ $t("service") }}
              <i class="fa fa-xs fa-question-circle cursor-pointer" :title="$t('service-description')"/>
            </label>
            <div class="w3-col zero flow-margin-right sort-select flow-btn-checkbox w3-left-align"
                 @click.prevent="()=> {domain.service = !domain.service}" v-bind:class="
                domain.service ? 'active' : 'inactive'">
              <div class="flow-btn-checkbox-icon">
                <i class="fa"></i>
              </div>
            </div>
          </div>
        </Row>
        <Row>
          <div class="grid-component">
            <label class="w3-left flow-main-color flow-padding-bottom">{{
              $t("domain-message")
            }}</label>
            <div class="w3-col w-100pc flow-margin-right sort-select">
              <StandardSelect
                :callback="setSelectedNotificationText"
                :items="getStandardTexts"
                :preSelectedItem="safeFormData.notificationText"
                :valueKey="'value'"
                :valueKeyIndex="'key'"
                class="w3-border w3-round-medium"
                type="text"
              />
            </div>
          </div>
          <div class="grid-component">
            <StandardTextBox
              :np-name-error="showMinutesError ? minutesError : ''"
              v-model:modelText="safeFormData.closingTimeMinutes"
              :label-name="'closing-message-threshold'"
              :placeholder="'minutes'"
              :is-number="true"
            />
          </div>
        </Row>
        <Row>
          <div class="grid-component">
            <StandardTextBox
              v-model:modelText="safeFormData.createdAt"
              is-disabled="is-disabled"
              :label-name="'created-at'"
              :placeholder="'created-at'"
            />
          </div>

          <div class="grid-component">
            <StandardTextBox
              v-model:modelText="safeFormData.updatedAt"
              is-disabled="is-disabled"
              :label-name="'updated-at-and-by'"
              :placeholder="'updated-at'"
            />
          </div>

          <div class="grid-component">
            <StandardTextBox
              v-model:modelText="safeFormData.updatedBy"
              is-disabled="is-disabled"
              :label-name="'updated-by'"
              :placeholder="'updated-by'"
            />
          </div>
        </Row>
      </Column>

      <div class="zero-bottom zero-top">
        <SaveButton
          :function-executed="updateExecuted"
          :on-add="
            () => {
              updateDomain();
            }
          "
        />

        <BackButton :on-clicked="() => sideFormStatusEvent('close')" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../common/ContentHeader";
import BackButton from "@/components/common/buttons/BackButton.vue";
import { mapActions, mapGetters } from "vuex";
import SaveButton from "@/components/common/buttons/SaveButton.vue";
import StandardTextBox from "@/components/common/StandardTextBox.vue";
import Column from "@/components/common/grid/Column.vue";
import Row from "@/components/common/grid/Row.vue";
import StandardSelect from "@/components/views/opening-hours/StandardSelect.vue";

export default {
  name: "EditDomainForm",
  components: {
    StandardSelect,
    Row,
    Column,
    StandardTextBox,
    SaveButton,
    BackButton,
    ContentHeader,
  },

  data() {
    return {
      domain: {},
      updateExecuted: false,
      showMinutesError: false,
      minutesError: "",
      prefixError: "",
    };
  },
  created() {
    this.domain = JSON.parse(JSON.stringify(this.onSelectedDomain));
    this.setDomain();
  },
  watch: {
    onSelectedDomain() {
      this.domain = JSON.parse(JSON.stringify(this.onSelectedDomain));
      if (this.domain && this.domain.notificationTextKey) {
        this.domain.notificationText = this.getStandardTexts.find(
          (item) => item.key === this.domain.notificationTextKey
        );
      }
    },
  },
  methods: {
    ...mapActions({
      sideFormStatusEvent: "eventHandlers/sideFormStatusEvent",
      updatedDomainEvent: "eventHandlers/updatedDomainEvent",
    }),
    checkClosingTimeMessageAndMinutes() {
      this.showMinutesError = false;
      this.minutesError = "";
      let minutes = this.safeFormData.closingTimeMinutes;
      let textKey = this.domain.notificationTextKey;

      if (minutes && (minutes > 180 || minutes < 0)) {
        this.showMinutesError = true;
        this.minutesError = this.$t("INVALID_MINUTES");
      } else if (minutes && minutes > 0 && !textKey) {
        this.showMinutesError = true;
        this.minutesError = this.$t("INVALID_NOTIFICATION_TEXT");
      } else if (textKey && (!minutes || minutes === 0 || minutes === "0")) {
        this.showMinutesError = true;
        this.minutesError = this.$t("INVALID_CLOSING_TIME_MINUTES");
      }
    },
    setSelectedNotificationText(item) {
      if (item) {
        this.domain.notificationText = item;
        this.domain.notificationTextKey = item.key;
      }
    },
    setDomain() {
      this.domain.notificationText = this.getStandardTexts.find(
        (item) => item.key === this.domain.notificationTextKey
      );
    },

    updateDomain() {
      if (
        !this.safeFormData.name ||
        !this.safeFormData.name.trim() ||
        !this.hasInputErrors()
      ) {
        return;
      }

      this.checkClosingTimeMessageAndMinutes();
      if (this.showMinutesError) {
        return;
      }

      let userId = this.$store.getters["users/getCurrentUser"].id;

      this.updateExecuted = true;

      Object.assign( this.domain, this.safeFormData);

      this.$restClient.domains
        .update(this.domain, userId)
        .then((response) => {
          // eslint-disable-next-line no-unused-vars
          console.log(response);
          this.updatedDomainEvent(this.domain);
          this.$notify.notifySuccess({
            title: this.$t("success"),
            message: this.$t("modified-success"),
          });
          this.sideFormStatusEvent("close");
        })
        .catch((err) => {
          this.updateExecuted = false;
          if (err && err.response.status === 400)
            this.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("domain-name-unique"),
            });
          console.log(err);
          this.$notify.notifyError({ title: this.$t("failed") });
        });
    },

    setSelectedType(option) {
      this.domain.type = option;
    },
    hasInputErrors() {
      let prefixError = "";
      const regex = /^[A-Za-z]{0,3}$/;

      if (!regex.test(this.safeFormData.prefix))
        prefixError = this.$t("INVALID_PREFIX");
      this.prefixError = prefixError;

      return this.prefixError === "";
    },
  },
  computed: {
    ...mapGetters({
      onSelectedDomain: "eventHandlers/onSelectedDomain",
      getDomainTypes: "eventHandlers/getDomainTypes",
      getStandardTexts: "eventHandlers/getStandardTexts",
    }),
    organization: {
      get() {
        if (this.domain && this.domain.type) {
          return this.domain.type.organization.name;
        } else {
          return "";
        }
      },
      // eslint-disable-next-line no-unused-vars
      set(val) {
        // no need to set organization
      },
    },
    safeFormData: {
      get() {
        return {
          id: this.domain.id,
          name: this.domain.name ?? "",
          prefix: this.domain.prefix ?? "",
          type: this.domain.type ?? "",
          notificationText: this.domain.notificationText ?? "",
          closingTimeMinutes: this.domain.closingTimeMinutes ?? "",
          createdAt: this.domain.createdAt ?? "",
          updatedAt: this.domain.updatedAt ?? "",
          updatedBy: this.domain.updatedBy ?? ""
        };
      }
    },
  },
};
</script>
